import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { history } from "../../../store/store";
import { OrganizationDetailsTab } from "./tabs/OrganizationDetailsTab";
import { ACL } from '../../../config/constants';
import { OrganizationUsersTab } from "./tabs/OrganizationUsersTab";
import { OrganizationOrdersTab } from "./tabs/OrganizationOrdersTab";
import { OrganizationReportsTab } from "./tabs/OrganizationReportsTab";
import { EntityTabLayout } from '../../layout/Workspace';

function OrganizationDetailsComponent(props) {
  const {
    organization, users, metaUsers, getOrganizationUsers, rowsPerPageUsers, setRowsPerPageUsers,
    orders, metaOrders, getOrganizationOrders, rowsPerPageOrders, setRowsPerPageOrders,
  } = props;
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState('organization');
  const hasReportsAccess = ACL.CLIENT.REPORTS.LIST.hasAccess();

  useEffect(() => {
    const tab = new URLSearchParams(props.location.search).get("tab");

    const allowedTabs = [
      'organization',
      ...(ACL.CLIENT.USERS.LIST.hasAccess() ? ['users'] : []),
      ...(ACL.CLIENT.ORDERS.LIST.hasAccess() ? ['orders'] : []),
      ...(hasReportsAccess ? ['reports'] : [])
    ];

    if (tab && allowedTabs.includes(tab)) {
      if (activeTab !== tab) {
        setActiveTab(tab);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      const params = new URLSearchParams(props.location && props.location.search);
      params.set('tab', tab);
      history.push({
        search: `?${params.toString()}`,
      });

      setActiveTab(tab);
    }
  };

  // Keep the former Reactstrap TabContent mounting contract so related-list
  // requests and local toolbar state do not change when switching sections.
  const tabPanels = (
    <div className="organization-detail-tab-panels">
      <div
        aria-hidden={activeTab !== 'organization'}
        className="organization-detail-tab-panel"
        hidden={activeTab !== 'organization'}
      >
        <OrganizationDetailsTab organization={organization}/>
      </div>
      {ACL.CLIENT.USERS.LIST.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'users'}
          className="organization-detail-tab-panel"
          hidden={activeTab !== 'users'}
        >
          <OrganizationUsersTab
            organization={organization}
            users={users}
            metaUsers={metaUsers}
            getOrganizationUsers={getOrganizationUsers}
            rowsPerPageUsers={rowsPerPageUsers}
            setRowsPerPageUsers={setRowsPerPageUsers}
          />
        </div>
      )}
      {ACL.CLIENT.ORDERS.LIST.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'orders'}
          className="organization-detail-tab-panel"
          hidden={activeTab !== 'orders'}
        >
          <OrganizationOrdersTab
            organization={organization}
            orders={orders}
            metaOrders={metaOrders}
            getOrganizationOrders={getOrganizationOrders}
            rowsPerPageOrders={rowsPerPageOrders}
            setRowsPerPageOrders={setRowsPerPageOrders}
          />
        </div>
      )}
      {hasReportsAccess && activeTab === 'reports' && (
        <div className="organization-detail-tab-panel">
          <OrganizationReportsTab
            location={props.location}
            organizationId={props.organizationId || organization?.id}
          />
        </div>
      )}
    </div>
  );
  const entityTabs = [{
    id: 'organization',
    label: <FormattedMessage id="fields.organization_details"/>,
    content: tabPanels
  }];

  if (ACL.CLIENT.USERS.LIST.hasAccess()) {
    entityTabs.push({
      id: 'users',
      label: <FormattedMessage id="fields.organization_users"/>,
      content: tabPanels
    });
  }

  if (ACL.CLIENT.ORDERS.LIST.hasAccess()) {
    entityTabs.push({
      id: 'orders',
      label: <FormattedMessage id="fields.organization_orders"/>,
      content: tabPanels
    });
  }

  if (hasReportsAccess) {
    entityTabs.push({
      id: 'reports',
      label: <FormattedMessage id="navigation.reports"/>,
      content: tabPanels
    });
  }

  const organizationName = organization?.id
    ? organization.name
    : intl.formatMessage({ id: 'pages.organization.title' });

  return (
    <EntityTabLayout
      activeTab={activeTab}
      ariaLabel={organizationName}
      className="organization-detail-layout"
      header={props.header}
      onTabChange={toggle}
      tabs={entityTabs}
    />
  );
}

OrganizationDetailsComponent.defaultProps = {
  header: null
};

const OrganizationDetails = connect(null, {})(OrganizationDetailsComponent);

export { OrganizationDetails, OrganizationDetailsComponent };
